import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View, type StyleType} from "@khanacademy/wonder-blocks-core";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelXSmall} from "@khanacademy/wonder-blocks-typography";

interface Props {
    /**
     * The content to be displayed.
     */
    content: string;

    /**
     * Optional styles to be applied to the container.
     */
    style?: StyleType;
}

/**
 * Renders a system message in chat.
 */
export const SystemMessage = (props: Props): React.ReactElement => {
    const {content, style} = props;
    return (
        <View
            style={[styles.systemMessage, style]}
            aria-label={t`System notification`}
        >
            <LabelXSmall style={styles.text}>{content}</LabelXSmall>
        </View>
    );
};

const styles = StyleSheet.create({
    systemMessage: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        color: semanticColor.core.foreground.neutral.subtle,
        gap: spacing.xSmall_8,
        flex: "0 0 auto",
        "::after": {
            content: '""',
            flex: "1 1 auto",
            height: 1,
            width: "100%",
            backgroundColor: semanticColor.core.background.neutral.default,
        },
        "::before": {
            content: '""',
            flex: "1 1 auto",
            height: 1,
            width: "100%",
            backgroundColor: semanticColor.core.background.neutral.default,
        },
    },
    text: {
        flex: "0 0 auto",
        maxWidth: "75%",
        textAlign: "center",
    },
});
